import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-cy"]

import { computed } from "vue";
import { useRoute } from "vue-router";
import {
  logStore,
  permissionStore,
  sessionApiStore,
  sessionStore,
} from "@/hooks";
import { AppConfirmModal, FlexBox } from "@/components/common";
import {
  SaveProjectModal,
  DeleteProjectModal,
  TransferProjectModal,
} from "@/components/project";
import { OnboardingPopup } from "@/components/onboarding";
import { JobLogModal } from "@/components/jobs";
import { AppNavDrawer } from "./sidebar";
import { AppNavBar } from "./topbar";
import { DetailsDrawer } from "./detailsDrawer";
import Snackbar from "./Snackbar.vue";


/**
 * Renders all app navigation components.
 */
const __default__ = {
  name: "AppNav",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const currentRoute = useRoute();

const displayLoading = computed(() => sessionApiStore.authLoading);
const displayNavigation = computed(
  () =>
    sessionStore.doesSessionExist &&
    !sessionApiStore.loading &&
    !currentRoute.meta.isPublic
);
const displaySidebar = computed(
  () => displayNavigation.value && permissionStore.isAllowed("safa.view")
);

const confirmationMessage = computed(() => logStore.confirmation);

return (_ctx: any,_cache: any) => {
  const _component_q_spinner_ball = _resolveComponent("q-spinner-ball")!

  return (_openBlock(), _createElementBlock("div", {
    "data-cy": displayNavigation.value ? 'is-logged-in' : ''
  }, [
    (displaySidebar.value)
      ? (_openBlock(), _createBlock(_unref(AppNavDrawer), { key: 0 }))
      : _createCommentVNode("", true),
    (displayNavigation.value)
      ? (_openBlock(), _createBlock(_unref(AppNavBar), { key: 1 }))
      : _createCommentVNode("", true),
    (displayNavigation.value)
      ? (_openBlock(), _createBlock(_unref(DetailsDrawer), { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(Snackbar),
    _createVNode(_unref(AppConfirmModal), { message: confirmationMessage.value }, null, 8, ["message"]),
    _createVNode(_unref(JobLogModal)),
    _createVNode(_unref(SaveProjectModal)),
    _createVNode(_unref(TransferProjectModal)),
    _createVNode(_unref(DeleteProjectModal)),
    _createVNode(_unref(OnboardingPopup)),
    (displayLoading.value)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 3,
          "full-width": "",
          justify: "center",
          align: "center",
          style: {"height":"100vh"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_spinner_ball, {
              class: "nav-gradient",
              size: "4em"
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})